<template>
  <h3 class="modal-title">
    <LuminanceMask
      class="modal-title__bg-left"
      :src="require('@/assets/images/other/toolbar-bg-left.jpg')"
      :stop-colors="[{ offset: '50%', color }]"
    />
    <div class="modal-title__bg">
      <LuminanceMask
        class="toolbar__bg-img"
        :src="require('@/assets/images/other/toolbar-bg-main.jpg')"
        :stop-colors="[{ offset: '50%', color }]"
      />
    </div>
    <slot />
  </h3>
</template>

<script>
import LuminanceMask from "@/components/ui/masks/LuminanceMask";

export default {
  name: "ModalTitle",
  components: {
    LuminanceMask
  },
  data: () => ({
    color: "#de0b42"
  })
};
</script>

<style lang="scss">
.modal-title {
  font-size: 30px;
  color: colors(text-3);
  font-weight: bold;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  padding: 0 30px;
  height: 83px;
  padding-right: 60px;

  &__bg-left {
    position: absolute;
    left: -15px;
    top: -30px;
    width: 283px;
    height: 126px;
    z-index: -1;
  }

  &__bg {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 83px;
    overflow: hidden;
    z-index: -1;
  }

  @include breakpoint("sm-and-down") {
    font-size: 24px;
    padding-left: 16px;
    padding-right: 40px;
  }
}
</style>
